import { queryClient } from 'src/boot/vue-query'
import { APIS, SERVICES } from 'src/config/constants'
import { QueryKey } from 'src/hooks/constants/queryKeys'
import type { ICustomEntity } from 'src/interfaces/custom'
import { axiosInstance } from 'src/utils/request'

const centerCustomizationsStaleTime = 60_000

const centerCustomizationsQueryKey = (orgId: string, centerId: string) => [
  QueryKey.CenterCustomizations,
  orgId,
  centerId,
]

const fetchCenterCustomizations = async (): Promise<ICustomEntity> => {
  const response = await axiosInstance.get<ICustomEntity>(
    `${SERVICES.res}/${APIS.customs}`,
  )
  return response.data
}

export const fetchCachedCenterCustomizations = async ({
  orgId,
  centerId,
}: {
  orgId?: string
  centerId?: string
}): Promise<ICustomEntity | undefined> => {
  if (!orgId || !centerId) return undefined

  return queryClient.fetchQuery({
    queryKey: centerCustomizationsQueryKey(orgId, centerId),
    queryFn: fetchCenterCustomizations,
    staleTime: centerCustomizationsStaleTime,
  })
}

export const getCachedCenterCustomizations = ({
  orgId,
  centerId,
}: {
  orgId?: string
  centerId?: string
}) => {
  if (!orgId || !centerId) return undefined
  return queryClient.getQueryData<ICustomEntity>(
    centerCustomizationsQueryKey(orgId, centerId),
  )
}
